import { AssertionError } from "./errors/index.js";
export function isEditableGridModel(model) {
  return (model === null || model === void 0 ? void 0 : model.isEditable) !== undefined;
}
export function assertIsEditableGridModel(model) {
  if (!isEditableGridModel(model)) {
    throw new AssertionError("Expected 'model' to be editable, but received ".concat(model));
  }
}

/**
 * Edit operation when applying multiple edits
 */

/**
 * Model for an editable grid
 */
//# sourceMappingURL=EditableGridModel.js.map